// src/components/Layout.js

import React from 'react';
import Header from './Header';
import Footer from './Footer';  // <-- He uncomment kara (jar Footer banavla asel tar)

const Layout = ({ children }) => {
  return (
    <div>
      <Header />
      <main style={{ minHeight: '80vh', padding: '20px' }}>
        {children}  {/* He yogya ahe, pages yachya madhe yetil */}
      </main>
      <Footer />  {/* <-- Yogya syntax: direct render kara, comment {} nako */}
    </div>
  );
};

export default Layout;